import React, { useEffect, useState, useCallback } from "react";
import axios from "../axios";
import "./GstPassword.css";

const API_URL = process.env.REACT_APP_API_URL;

const GstPassword = () => {
  const [records, setRecords] = useState([]);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const getAuthHeaders = () => {
    const token = localStorage.getItem("access_token");
    return {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
  };
  


  const [formData, setFormData] = useState({
    trade_name: "",
    client_name: "",
    gst_number: "",
    contact_number: "",
    user_name: "",
    password: "",
    eway_username: "",
    eway_password: "",
    email_id: "",
    email_password: "",
  });

  const fetchData = useCallback(async () => {
    const res = await axios.get(`${API_URL}api/gst/`, {
      headers: getAuthHeaders(),
    });
    setRecords(res.data);
  }, []);
  
  useEffect(() => {
    fetchData();
  }, [fetchData]);
  

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const requiredFields = [
      "trade_name",
      "client_name",
      "gst_number",
      "contact_number",
      "user_name",
      "password",
    ];
  
    for (let field of requiredFields) {
      if (!formData[field]) {
        alert(`❌ Please fill in: ${field.replaceAll("_", " ")}`);
        return;
      }
    }
  
    try {
      const config = { headers: getAuthHeaders() }; // ✅ Reuse token headers
  
      if (editingId) {
        await axios.put(`${API_URL}api/gst/${editingId}/`, formData, config);
      } else {
        await axios.post(`${API_URL}api/gst/`, formData, config);
      }
  
      // Reset form
      setFormData({
        trade_name: "",
        client_name: "",
        gst_number: "",
        contact_number: "",
        user_name: "",
        password: "",
        eway_username: "",
        eway_password: "",
        email_id: "",
        email_password: "",
      });
      setEditingId(null);
      setIsFormVisible(false);
      fetchData();
    } catch (err) {
      console.error("❌ Error submitting data:", err.response?.data || err.message);
      alert("Unauthorized or invalid input.");
    }
  };
  

  const handleEdit = (record) => {
    setFormData(record);
    setEditingId(record.id);
    setIsFormVisible(true);
  };

  const handleDelete = async (id) => {
    await axios.delete(`${API_URL}api/gst/${id}/`);
    fetchData();
  };

  return (
    <div className="gst-container">
      <h2 className="section-title">GST Password Management</h2>

      <button
        onClick={() => {
          setFormData({
            trade_name: "",
            client_name: "",
            gst_number: "",
            contact_number: "",
            user_name: "",
            password: "",
            eway_username: "",
            eway_password: "",
            email_id: "",
            email_password: "",
          });
          setEditingId(null);
          setIsFormVisible(true);
        }}
        className="submit-btn"
        style={{ marginBottom: "20px" }}
      >
        ➕ Add New Record
      </button>
      <input
  type="text"
  placeholder="🔍 Search by trade name..."
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
  className="search-input"
/>


      {isFormVisible && (
        <form className="gst-form" onSubmit={handleSubmit}>
          <div className="form-grid">
            {Object.entries(formData).map(([key, value]) => (
              <div key={key} className="form-group">
                <label>{key.replaceAll("_", " ")}</label>
                <input
                  type="text"
                  name={key}
                  value={value}
                  onChange={handleChange}
                />
              </div>
            ))}
          </div>
          <button type="submit" className="submit-btn">
            {editingId ? "Update" : "Create"}
          </button>
        </form>
      )}

      <div className="table-wrapper">
        <table className="records-table">
          <thead>
            <tr>
              <th>Trade Name</th>
              <th>Client Name</th>
              <th>GST No</th>
              <th>Contact</th>
              <th>User</th>
              <th>Password</th>
              <th>E-way User</th>
              <th>E-way Pass</th>
              <th>Email</th>
              <th>Email Pass</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
          {records
      .filter((rec) =>
        rec.trade_name.toLowerCase().includes(searchTerm.toLowerCase())
      )
      .map((rec) => (
        <tr key={rec.id}>
          <td>{rec.trade_name}</td>
          <td>{rec.client_name}</td>
          <td>{rec.gst_number}</td>
          <td>{rec.contact_number}</td>
          <td>{rec.user_name}</td>
          <td>{rec.password}</td>
          <td>{rec.eway_username}</td>
          <td>{rec.eway_password}</td>
          <td>{rec.email_id}</td>
          <td>{rec.email_password}</td>
          <td>
            <button onClick={() => handleEdit(rec)} className="edit-btn">
              Edit
            </button>
            <button onClick={() => handleDelete(rec.id)} className="delete-btn">
              Delete
            </button>
          </td>
        </tr>
      ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GstPassword;
